<script>
/**
 * 処理後物の種類
 */

import InfiniteAutocomplete from "@/driver/components/InfiniteAutocomplete.vue";
import {mapActions} from "vuex";

export default {
  name: "InfiniteAfterDisposalItemSubcategoryAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /**
     * 処理後物の種類ID
     */
    subcategoryId: {
      type: [String, Number],
      default: null
    },
    categoryName: {
      type: String,
      default: null
    },
    /**
     * after_industrial: 廃棄物, after_recycling: 再資源化物
     */
    afterType: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "処分後物の種類",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      members: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
      workableCategoryName: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 処理後物の種類ID 変更検知
     * @param newValue
     * @param oldValue
     */
    subcategoryId (newValue, oldValue) {
      this.workableId = newValue;
      if (newValue !== oldValue) {
        this.loadMembers();
      }
    },

    /**
     * 処理後物の大分類名の変更検知
     * @param newValue
     * @param oldValue
     */
    categoryName(newValue, oldValue) {
      this.workableCategoryName = newValue;
      if (newValue !== oldValue) {
        this.loadMembers();
      }
    },

    /**
     * 作業用処理後物の種類IDの変更検知
     */
    workableId() {
      this.returnValues();
    },

    afterType() {
      this.loadMembers();
    }

  },
  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.categoryName) {
      this.workableCategoryName = this.categoryName;
      this.loadMembers();
    } else {
      this.fetchMembers();
    }
  },

  methods: {
    ...mapActions("DriverMasterSearchAfterDisposalItemSubcategory", {
      fetchAfterDisposalItemSubcategories: 'index',
    }),

    /**
     * クリア コールバック
     */
    clearCallback() {
      this.workableId = null;
      this.$emit("update:values", null);
      this.reloadMembers();
    },

    /**
     * 初期ロード, 連動時に実行する.
     */
    loadMembers() {
      const conditions = {
        after_type: this.afterType,
        category_name: this.categoryName,
        subcategory_id: this.subcategoryId,
        page: 1,
      };

      this.fetchAfterDisposalItemSubcategories({ ...conditions }).then((response) => {
        this.members = response.after_disposal_items;
        if (this.members.length === 1) {
          this.workableId = this.members[0].value;
        }
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },

    /**
     * リロード処理
     */
    reloadMembers() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.members = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchMembers();
    },

    /**
     * 取得アクション
     * @returns {Promise<unknown>}
     */
    fetchMembers() {
      this.loading = true;
      const conditions = {
        after_type: this.afterType,
        query: this.searchKeyword,
        category_name: this.workableCategoryName,
        page: this.pageNumber,
      };
      this.fetchAfterDisposalItemSubcategories({ ...conditions }).then((response) => {
        this.members = this.members.concat(response.after_disposal_items);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchMembers();
      }
    },

    /**
     * エンターキー キーダウンコールバック
     * @param value
     */
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchMembers();
    },

    /**
     * 呼び出し元への戻し
     */
    returnValues() {
      if (this.members.length > 0) {
        const object = this.members.find((member) => member.value === this.workableId);
        this.$emit("update:values", object);
      }
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="{ errors }"
    :value="workableId"
    :rules="{ required: required }"
    :class="{ requiredMark: required }"
    :name="label"
  >
    <infinite-autocomplete
      v-model="workableId"
      :classes="classes"
      :disabled="disabled"
      :error-messages="errors"
      :label="label"
      :loading="loading"
      :members="members"
      :pagination="pagination"
      :rounded="rounded"
      @click:clear="clearCallback"
      @insect="insectCallback"
      @keydown:enter="enterKeydownCallback"
    >
      <template v-slot:item="{ item }">
        {{ item.code }}:{{ item.text }}
      </template>
    </infinite-autocomplete>
  </validation-provider>
</template>

<style scoped lang="scss">

</style>
